module.exports = __webpack_public_path__ + "static/media/gps.bcfb88cb.svg";